// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.specific-strategies-sidebar {
  flex: 0 0 auto;
}

.specific-strategies-dropdown {
  width: 100%;
}

.specific-strategies-dropdown .wheel-window {
  width: 100%;
}

.specific-strategies-dropdown__value {
  white-space: nowrap;
}

.specific-strategies-dropdown__menu {
  left: auto;
  right: 0;
  min-width: 100%;
}

.specific-strategies-dropdown .oars-dropdown-trigger.disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.specific-strategies-sidebar__drawer-report {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.specific-strategies-sidebar__drawer-report .oars-analytics-shell,
.specific-strategies-sidebar__drawer-report .in-session-analytics,
.specific-strategies-sidebar__drawer-report .oars-context-panel {
  min-height: 0;
  border: 0;
  box-shadow: none;
}

.specific-strategies-sidebar-feedback {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.specific-strategies-sidebar-feedback__body {
  min-height: 100%;
}

.specific-strategies-sidebar__action-dock {
  flex: 0 0 auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/sidebar/SpecificStrategiesSidebarPanel.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".specific-strategies-sidebar {\n  flex: 0 0 auto;\n}\n\n.specific-strategies-dropdown {\n  width: 100%;\n}\n\n.specific-strategies-dropdown .wheel-window {\n  width: 100%;\n}\n\n.specific-strategies-dropdown__value {\n  white-space: nowrap;\n}\n\n.specific-strategies-dropdown__menu {\n  left: auto;\n  right: 0;\n  min-width: 100%;\n}\n\n.specific-strategies-dropdown .oars-dropdown-trigger.disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.specific-strategies-sidebar__drawer-report {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.specific-strategies-sidebar__drawer-report .oars-analytics-shell,\n.specific-strategies-sidebar__drawer-report .in-session-analytics,\n.specific-strategies-sidebar__drawer-report .oars-context-panel {\n  min-height: 0;\n  border: 0;\n  box-shadow: none;\n}\n\n.specific-strategies-sidebar-feedback {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.specific-strategies-sidebar-feedback__body {\n  min-height: 100%;\n}\n\n.specific-strategies-sidebar__action-dock {\n  flex: 0 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
